import React from "react";
import PropTypes from "prop-types";

import "./Main.scss";

const Main = ({ children, className }) => {
     return <main className={`Main ${className}`}>{children}</main>;
};

export default Main;

Main.propTypes = {
     children: PropTypes.node.isRequired,
};
